import { addNotificationToApp, NotificationType } from './NotificationsActions';
import { PolicyId, EnrollmentPackageId } from '../types/api/primaryKeys/PrimaryKey';
import { ReduxDispatch } from '../types/redux/ReduxDispatch';
import * as Api from '../apiCalls/beneficiaries/beneficiaryApiCalls';
import { PolicyBeneficiary } from '../types/api/beneficiaries/PolicyBeneficiary';

export enum BeneficiaryActionType {
    FETCH_BENEFICIARIES = "FETCH_BENEFICIARIES",
    FETCH_BENEFICIARIES_SUCCESS = "FETCH_BENEFICIARIES_SUCCESS",
    FETCH_BENEFICIARIES_FAILURE = "FETCH_BENEFICIARIES_FAILURE",
    FETCH_UPDATE_BENEFICIARIES = "FETCH_UPDATE_BENEFICIARIES",
    FETCH_UPDATE_BENEFICIARIES_SUCCESS = "FETCH_UPDATE_BENEFICIARIES_SUCCESS",
    FETCH_UPDATE_BENEFICIARIES_FAILURE = "FETCH_UPDATE_BENEFICIARIES_FAILURE"
}

export type BeneficiaryAction =
    | ReturnType<typeof requestFetchBeneficiaries>
    | ReturnType<typeof requestFetchBeneficiariesSuccess>
    | ReturnType<typeof requestFetchBeneficiariesFailure>
    | ReturnType<typeof requestFetchUpdateBeneficiaries>
    | ReturnType<typeof requestFetchUpdateBeneficiariesSuccess>
    | ReturnType<typeof requestFetchUpdateBeneficiariesFailure>;


function requestFetchBeneficiaries() {
    return {
        type: BeneficiaryActionType.FETCH_BENEFICIARIES
    } as const;
}

function requestFetchBeneficiariesSuccess(beneficiaries: readonly PolicyBeneficiary[]) {
    return {
        type: BeneficiaryActionType.FETCH_BENEFICIARIES_SUCCESS,
        payload: beneficiaries
    } as const;
}

function requestFetchBeneficiariesFailure(error: unknown) {
    return {
        type: BeneficiaryActionType.FETCH_BENEFICIARIES_FAILURE,
        payload: error
    } as const;
}

export function fetchBeneficiaries(policyId: PolicyId, packageId: EnrollmentPackageId) {
    return async (dispatch: ReduxDispatch) => {
        dispatch(requestFetchBeneficiaries());

        try {
            const json = await Api.getBeneficiaryDataForPolicy(policyId, packageId);
            dispatch(requestFetchBeneficiariesSuccess(json));
            return json;
        }
        catch (err) {
            dispatch(requestFetchBeneficiariesFailure(err));
            dispatch(addNotificationToApp("Failed To Get Beneficiaries", NotificationType.Error));
        }
    };
}

function requestFetchUpdateBeneficiaries() {
    return {
        type: BeneficiaryActionType.FETCH_UPDATE_BENEFICIARIES
    } as const;
}

 function requestFetchUpdateBeneficiariesSuccess() {
    return {
        type: BeneficiaryActionType.FETCH_UPDATE_BENEFICIARIES_SUCCESS
    } as const;
}

function requestFetchUpdateBeneficiariesFailure(error: unknown) {
    return {
        type: BeneficiaryActionType.FETCH_UPDATE_BENEFICIARIES_FAILURE,
        payload: error
    } as const;
}

export function fetchUpdateBeneficiaries(policyId: PolicyId, packageId: EnrollmentPackageId, beneficiaries: readonly PolicyBeneficiary[]) {
    return async (dispatch: ReduxDispatch) => {
        dispatch(requestFetchUpdateBeneficiaries());

        try {
            await Api.updateBeneficiaries(policyId, packageId, beneficiaries);
            dispatch(requestFetchUpdateBeneficiariesSuccess());
        }
        catch (err) {
            dispatch(requestFetchUpdateBeneficiariesFailure(err));
            dispatch(addNotificationToApp("Failed To Update Beneficiaries", NotificationType.Error));
        }
    };
}